import React from "react";
import { useTranslation } from "utilities/i18n";
import { getInsightTitleTranslation } from "utilities/insights";
import { InsightDetailsCard } from "./InsightDetailsCard";
import { SimilarInsightsFragment } from "generated/graphql";
import { findRelativeTimePeriod, tMetric } from "collections/InsightDetails";
import { getDataGroupByParam } from "../Priority/PriorityInsights";

export const SimilarInsightsCard: React.FC<{
  data: SimilarInsightsFragment;
  loading: boolean;
}> = ({ data, loading }) => {
  const { t } = useTranslation();
  const mt = tMetric();
  // TODO link to insight by id
  return (
    <InsightDetailsCard className="similar-insights-card">
      <div
        data-testid={`similarindicator${
          data.indicator.__typename === "AverageIndicator"
            ? data.indicator.average
            : data.indicator.count
        }`}
        className="similar-insight"
      >
        {mt(data.indicator)}
      </div>
      <div className="similar-content">
        <div className="similar-desc">
          {t("INSIGHT_IN_SITE", {
            title: getInsightTitleTranslation(data.topic.id),
            site: getDataGroupByParam(data)
          })}
        </div>
        <div className="similar-interval">
          {findRelativeTimePeriod(data.timePeriodStart || "", data.timeScope)}
        </div>
      </div>
    </InsightDetailsCard>
  );
};
